<div class='switch'>
  <label>
    <span class='sr-only'>{{ 'SHARED.SWITCH.ACTIVATE_OPTION' | translate }}</span>
    <input type='checkbox' [checked]='checked' [disabled]='disabled' (change)='onToggle($event)' [attr.aria-checked]='checked' attr.aria-label="{{ 'SHARED.SWITCH.ACTIVATE_OPTION' | translate }}">
    <span class='lever'></span>
  </label>
</div>